import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  useLocation
} from "react-router-dom";

import SideMenu from "./ReportsSideMenu";
import LeaseReportSummary from "./reportlist/LeaseReport"; // "../masters/clientDirectory/ClientProfile";
import LeaseLockinExpiryReport from "./reportlist/LeaseLockinExpiryReport";
import LeaseExpiryReport from "./reportlist/LeaseExpiryReport";
import LeaseDocumentation from "./reportlist/LeaseDocumentation";
// import UnitDetailMaster from "./storeDirectory/UnitDetailMaster";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import ListingForm from "./reportlist/ListingForm";
import LeaseReportSalesForecast from "./reportlist/LeaseReportSalesForecast";

import LeaseReportSalesActual from "./reportlist/LeaseReportSalesActual";
import LeaseReportSalesView from "./reportlist/LeaseReportSalesView";
import LeaseReportSalesComparison from "./reportlist/LeaseReportSalesComparison";
import LeaseSecurityDeposit from "./reportlist/LeaseSecurityDeposit";
import InputSecurityDeposit from "./reportlist/InputSecurityDeposit";
import SecurityDepositComparison from "./reportlist/SecurityDepositComparison";
import RevenueReport from "./reportlist/RevenueReport";
import ExpenseReport from "./reportlist/ExpenseReport";
import MgWithRevenueReport from "./reportlist/MgWithRevenueReport"

import RevenueLockinReport from "./reportlist/RevenueLockinReport";
import MgVsRevenueReport from "./reportlist/MgVsRevenueReport"
import EscalationReport from "./reportlist/EscalationReport";
import LeaseTracker from "./reportlist/LeaseTracker";
import ComplianceTracker from "./reportlist/ComplianceTracker";
import FranchiseeReport from "./reportlist/FranchiseeReport"
import ClausesReport from "./reportlist/ClausesReport"
import LeaseReportSalesViewHorizonal from "./reportlist/LeaseReportSalesViewHorizonal";
import LeaseReportSalesComparisonHorizontal from "./reportlist/LeaseReportSalesComparisonHorizontal";
import StackingPlan from "./reportlist/StackingPlan"

import ChargeReceiptUpload from "./reportlist/ChargeReceiptUpload";
import ChargeReceiptReport from "./reportlist/ChargeReceiptReport";
import FinanceInput from "./reportlist/FinanceInput";
import FinancePayment  from "./reportlist/FinancePayment";
import FinanceReconciliation from "./reportlist/FinanceReconciliation";

import Outflow from "./reportlist/OutflowReport.js";

import LeaseGiftVoucherForecast from "./reportlist/LeaseVoucherForecast";
import LeaseGiftVoucherActual from "./reportlist/LeaseGiftVoucherActual";
import LeaseGiftVoucherView from "./reportlist/LeaseGiftVoucherView";
import GiftVoucherIssueComponent from "./reportlist/GiftVoucherIssueComponent";

import CamActualizationActual from "./reportlist/CamActualizationActual";
import CamActualizationView from "./reportlist/CamActualizationView";
// import CloseDeals from "./reportlist/CloseDealsReport.js";
import AcquisitionReport from "./reportlist/AcquisitionReport";
import ValuationReport from "./reportlist/ValuationReport";
import AssetManagementReport from "./reportlist/AssetManagementReport";




import TopHeader from "../layout/TopHeader";

import { getUserRole } from "../utils/index";
//import CamActualizationView from "./reportlist/CamActualizationView";

export default function ViewLease() {
  let match = useRouteMatch();
  let location = useLocation();
  const parts = location.pathname.split('/');

  let urlArray = {
    'lease-report':{'openMenu':'1', 'activeKey':'1-1'},
    'lease-expiry-report':{'openMenu':'1', 'activeKey':'1-2'},
    'lease-lockin-expiry':{'openMenu':'1', 'activeKey':'1-3'},
    'stacking-plan':{'openMenu':'1', 'activeKey':'1-4'},
    'lease-tracker':{'openMenu':'1', 'activeKey':'1-5'},
    'franchisee-report':{'openMenu':'1', 'activeKey':'1-6'},
    'clauses-report':{'openMenu':'1', 'activeKey':'1-7'},
    'lease-report-sales-forecast':{'openMenu':'2', 'activeKey':'2-1'},
    'lease-report-sales-actual':{'openMenu':'2', 'activeKey':'2-2'},
    'lease-report-sales-view':{'openMenu':'2', 'activeKey':'2-3'},
    'lease-report-sales-comparison':{'openMenu':'2', 'activeKey':'2-4'},
    'lease-and-sales-portfolio-view':{'openMenu':'2', 'activeKey':'2-5'},
    'revenue-report':{'openMenu':'3', 'activeKey':'3-1'},
    'lockin-revenue-report':{'openMenu':'3', 'activeKey':'3-2'},
    'escalation-report':{'openMenu':'3', 'activeKey':'3-3'},    
    'mg-vs-revenue':{'openMenu':'3', 'activeKey':'3-4'},
    'charge-receipt-upload':{'openMenu':'3', 'activeKey':'3-5'},
    'charge-receipt-report':{'openMenu':'3', 'activeKey':'3-6'},
    'mg-revenue-report':{'openMenu':'3', 'activeKey':'3-7'},
    'lease-security-deposit':{'openMenu':'4', 'activeKey':'4-1'},
    'input-security-deposit':{'openMenu':'4', 'activeKey':'4-2'},
    'security-deposit-comparison':{'openMenu':'4', 'activeKey':'4-3'},
    'lease-documentation':{'openMenu':'5', 'activeKey':'5-1'},
    'outflow':{'openMenu':'6', 'activeKey':'6-1'},
    'compliance-tracker':{'openMenu':'7', 'activeKey':'7-1'},
    'gift-vouchers':{'openMenu':'8', 'activeKey':'8-1'},
    'gift-vouchers-actual':{'openMenu':'8', 'activeKey':'8-2'},
    'gift-vouchers-view':{'openMenu':'8', 'activeKey':'8-3'},
    'cam-actualization-actual':{'openMenu':'9', 'activeKey':'9-1'},
    'cam-actualization-view':{'openMenu':'9', 'activeKey':'9-2'},
    'acquisition-report':{'openMenu':'10', 'activeKey':'10-1'},
    'asset-management-report':{'openMenu':'10', 'activeKey':'10-2'},
    'valuation-report':{'openMenu':'10', 'activeKey':'10-3'},
    'finance-input':{'openMenu':'11', 'activeKey':'11-1'},
    'finance-payment':{'openMenu':'11', 'activeKey':'11-2'},
    'finance-reconciliation':{'openMenu':'11', 'activeKey':'11-3'},
  };
  
  let openMenu = urlArray[parts[2]]?.openMenu ?? '1';
  let activeKey = urlArray[parts[2]]?.activeKey ?? '1-1';
  //console.log(activeKey, "activeKey")
  let reportArr = [
    /* { 'link' : 'report-1', 'name': 'Report 1', 'CustomeParams' : 'value', 'subChild' : [
        { 'link' : 'sub report-1', 'name': 'Sub Report 2', 'CustomeParams' : 'value' }, 
       { 'link' : 'suub report-1', 'name': 'Sub Report 3', 'CustomeParams' : 'value' }
     ] },
     { 'link' : 'report-1', 'name': 'Report 2', 'CustomeParams' : 'value' }, 
     { 'link' : 'report-1', 'name': 'Report 3', 'CustomeParams' : 'value' },*/
  ];

  return (
    <div>
      <TopHeader />
      <div className="masterContainer">
        <div className="masterClassMain mt-4">
          {(getUserRole() != "checker" || true) && (
            <>
              <SideMenu openMenu={openMenu} activeKey={activeKey} reports_list={reportArr} />
              <Switch>
                <Route path={`${match.path}/report-12`}>
                  <LeaseReportSummary path1="report-12" />
                </Route>

                <Route path={`${match.path}/lease-lockin-expiry`}>
                  <LeaseLockinExpiryReport path1="report-21" />
                </Route>
                <Route path={`${match.path}/lease-expiry-report///:leaseMonths`}>
                  <LeaseExpiryReport />
                </Route>
                <Route path={`${match.path}/lease-expiry-report/:brand//:leaseMonths`}>
                  <LeaseExpiryReport />
                </Route>
                <Route path={`${match.path}/lease-expiry-report//:state/:leaseMonths`}>
                  <LeaseExpiryReport />
                </Route>
                <Route path={`${match.path}/lease-expiry-report/:brand/:state/:leaseMonths`}>
                  <LeaseExpiryReport />
                </Route>
                <Route path={`${match.path}/lease-expiry-report`}>
                  <LeaseExpiryReport />
                </Route>
                <Route path={`${match.path}/lease-report`}>
                  {/* <ClientAccessSetup path1='report-21'  /> */}
                  <LeaseReportSummary />
                </Route>
                <Route path={`${match.path}/lease-documentation`}>
                  <LeaseDocumentation />
                </Route>
                <Route path={`${match.path}/stacking-plan`}>
                  <StackingPlan />
                </Route>
                <Route path={`${match.path}/lease-report-sales-forecast`}>
                  <LeaseReportSalesForecast />
                </Route>
                <Route path={`${match.path}/lease-report-sales-actual`}>
                  <LeaseReportSalesActual />
                </Route>
                <Route path={`${match.path}/lease-report-sales-view`}>
                  <LeaseReportSalesView />
                </Route>
                <Route path={`${match.path}/lease-report-sales-comparison`}>
                  <LeaseReportSalesComparison />
                </Route>
                <Route path={`${match.path}/lease-security-deposit`}>
                  <LeaseSecurityDeposit />
                </Route>
                <Route path={`${match.path}/input-security-deposit`}>
                  <InputSecurityDeposit />
                </Route>
                <Route path={`${match.path}/security-deposit-comparison`}>
                  <SecurityDepositComparison />
                </Route>

                <Route path={`${match.path}/revenue-report`}>
                  <RevenueReport />
                </Route>
                <Route path={`${match.path}/expense-report`}>
                  <ExpenseReport />
                </Route>
                <Route path={`${match.path}/charge-receipt-upload`}>
                  <ChargeReceiptUpload />
                </Route>
                <Route path={`${match.path}/charge-receipt-report`}>
                  <ChargeReceiptReport />
                </Route>


                <Route path={`${match.path}/mg-revenue-report`}>
                  <MgWithRevenueReport />
                </Route>

                <Route path={`${match.path}/lockin-revenue-report`}>
                  <RevenueLockinReport />
                </Route>
                <Route path={`${match.path}/mg-vs-revenue`}>
                  <MgVsRevenueReport />
                </Route>


                <Route path={`${match.path}/escalation-report`}>
                  <EscalationReport />
                </Route>


                <Route path={`${match.path}/lease-tracker`}>
                  <LeaseTracker />
                </Route>
                <Route path={`${match.path}/compliance-tracker`}>
                  <ComplianceTracker />
                </Route>
                <Route path={`${match.path}/franchisee-report`}>
                  <FranchiseeReport />
                </Route>
                <Route path={`${match.path}/clauses-report`}>
                  <ClausesReport />
                </Route>




                <Route path={`${match.path}/lease-and-sales-view`}>
                  <LeaseReportSalesViewHorizonal />
                </Route>
                <Route path={`${match.path}/lease-and-sales-portfolio-view`}>
                  <LeaseReportSalesComparisonHorizontal />
                </Route>

                <Route path={`${match.path}/outflow`}>
                  <Outflow />
                </Route>
                {/* <Route path={`${match.path}/update-setting/:id`}>
            <AlertSetting />
          </Route> */}


                {/* gift vouchers */}
                {/* <Route path={`${match.path}/gift-vouchers-forecast`}>
            <LeaseGiftVoucherForecast />
          </Route> */}
                <Route path={`${match.path}/gift-vouchers`}>
                  <GiftVoucherIssueComponent />
                </Route>

                <Route path={`${match.path}/gift-vouchers-actual`}>
                  <LeaseGiftVoucherActual />
                </Route>
                <Route path={`${match.path}/gift-vouchers-view`}>
                  <LeaseGiftVoucherView />
                </Route>

                <Route path={`${match.path}/cam-actualization-actual`}>
                  <CamActualizationActual />
                </Route>
                <Route path={`${match.path}/cam-actualization-view`}>
                  <CamActualizationView />
                </Route>

                <Route path={`${match.path}/acquisition-report`}>
                  <AcquisitionReport />
                </Route>

                <Route path={`${match.path}/asset-management-report`}>
                  <AssetManagementReport />
                </Route>

                <Route path={`${match.path}/valuation-report`}>
                  <ValuationReport />
                </Route>

                <Route path={`${match.path}/finance-input`}>
                  <FinanceInput />
                </Route>
                <Route path={`${match.path}/finance-payment`}>
                  <FinancePayment />
                </Route>
                <Route path={`${match.path}/finance-reconciliation`}>
                  <FinanceReconciliation />
                </Route>

                


                <Route path={`${match.path}`}>
                  {/* <div className="container">
                    <div className="row">
                      <div className="col-lg-12 mt20">
                        <h1 className="text-center">
                          <FontAwesomeIcon icon={faFileAlt} size="lg" />
                          <span>REPORTS</span>
                        </h1>
                      </div>
                    </div>
                  </div> */}
                  <LeaseReportSummary />
                </Route>


              </Switch>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
